module.exports = __webpack_public_path__ + "img/checkbox-unchecked.4e3006a4.svg";